module.exports = function () {
  return '<div class="factionbar" id="factionbar"></div>';
};